<!--
	TileMenu.svelte
-->

<script>
    import { hasSessionRoles } from '../../common/auth.js';
    import { ROLE_REVIEW_WRITE } from '../../common/roles-actions.js';

    // TCARE components
    import Tile from './Tile.svelte';

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiMagnify, mdiMenu, mdiDatabase, mdiPlusBox, mdiCardAccountDetailsOutline, mdiMapMarker } from '@mdi/js';
	// import { mdiCharity, mdiAccountSearch, mdiAccountArrowRight, mdiAccountMultiple } from '@mdi/js';
    

</script>

<style>
    .tile-menu {
        margin: auto;
        /* width: 80%; */
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-around;
        /* justify-content: space-between; */
        /* justify-content: flex-start; */
        /* border: 1px solid red; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="tile-menu">
        <Tile route={'/search'} label={'Search'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiMagnify} /></Icon>
        </Tile>

        <Tile route={'/explorer'} label={'Resource Explorer'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCardAccountDetailsOutline} /></Icon>
        </Tile>

        {#if hasSessionRoles([ROLE_REVIEW_WRITE])}
            <Tile route={'/reviews'} label={'Reviews'}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiDatabase} /></Icon>
            </Tile>
        {/if}

        <Tile route={'/create_service'} label={'Create Service'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiPlusBox} /></Icon>
        </Tile>

        <!-- TODO: add CoveragePage -->
        <!--
        <Tile route={''} label={'Coverage'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiMapMarker} /></Icon>
        </Tile>
        -->

        <!-- the tiles below have empty page routes assigned as of 10/4/22 -->
        
        <!--
        <Tile route={'/my-resources'} label={'My Services'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCharity} /></Icon>
        </Tile>

        <Tile route={'/my-searches'} label={'My Searches'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiAccountSearch} /></Icon>
        </Tile>

        <Tile route={'/my-referrals'} label={'My Referrals'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiAccountArrowRight} /></Icon>
        </Tile>

        <Tile route={'/my-partners'} label={'My Partners'}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiAccountMultiple} /></Icon>
        </Tile>
        -->
        
</div>

